module.exports = __webpack_public_path__ + "static/media/5DPO12.b2b39e85.jpg";